/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/17
 */
import './index.css';
import React, {Component} from 'react';
import RcDialog from 'rc-dialog';
import Close from '../../../svgs/close';
import Button from '../button';

class Dialog extends Component {
  constructor (props) {
    super(props);
    this.prefix = 'store-dialog';
  }
  state = {
    visible: this.props.visible
  }

  onClose = e => {
    this.setState({visible: false});
  }

  getCloseButton () {
    return <Button shape="circle"
       className={`${this.prefix}-close`}
       onClick={this.props.onClose}>
      <Close />
    </Button>
  }
  render () {
    const defaultStyle = {
      width: 480
    };
    return <RcDialog
      className={this.props.className}
      style={this.props.style ? this.props.style : defaultStyle}
      footer={this.props.closable ? this.getCloseButton() : ''}
      closable={false}
      animation="zoom"
      maskAnimation="fade"
      prefixCls={this.prefix}
      visible={this.props.visible}
      onClose={this.onClose}
    >
      {this.props.children}
      <Button className={`${this.prefix}-sure`} size="large" onClick={this.props.onClose}>确定</Button>
    </RcDialog>
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/lib/dialog/index.js